import Swal from 'sweetalert2';
import i18n from '@/i18n';
import { extensionToMimeType } from '@/config/constants';
import { showMessage } from '@/utils/messages';

function checkPermission(role) {
    const user = JSON.parse(localStorage.getItem('user'));
    let roleUser = user.role;
    let permission = roleUser.permissions;
    if (Array.isArray(role)) {
        let mapNameRole = permission.map((item) => item.name);
        const result = role.some((rl) => mapNameRole.includes(rl));
        return result;
    } else {
        let index = permission.findIndex((x) => {
            return x.name === role;
        });
        if (index >= 0) {
            return true;
        } else {
            return false;
        }
    }
}

//管理者 quan ly  administrator
//営業 kinh doanh sale
//ディレクション huong dan instructor
//parter
//part_time
function checkPermissionName(listRole) {
    const user = JSON.parse(localStorage.getItem('user'));
    let role = user.role ? user.role.name : '';
    if (listRole.includes(role)) {
        return true;
    } else {
        return false;
    }
}

function isValidDate(dateString) {
    // Kiểm tra định dạng ngày tháng năm (DD/MM/YYYY)
    const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

    if (!dateRegex.test(dateString)) {
        // Nếu không đúng định dạng, trả về false
        return false;
    }

    // Chuyển đổi chuỗi thành đối tượng Date
    const parts = dateString.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    // Tạo đối tượng Date và kiểm tra ngày có tồn tại không
    const dateObject = new Date(year, month - 1, day); // month - 1 vì tháng trong JavaScript bắt đầu từ 0

    // Kiểm tra xem ngày có tồn tại trong tháng không
    if (dateObject.getFullYear() === year && dateObject.getMonth() === month - 1 && dateObject.getDate() === day) {
        // Kiểm tra xem ngày có hợp lệ trong tháng không
        const lastDayOfMonth = new Date(year, month, 0).getDate();
        return day >= 1 && day <= lastDayOfMonth;
    }

    return false;
}

function onHandleShowConfirm(configConfirm) {
    return Swal.fire({
        title: configConfirm?.title ?? ``,
        text: configConfirm?.text ?? i18n.t('confirmCommon'),
        icon: configConfirm?.icon ?? 'warning',
        allowOutsideClick: configConfirm?.allowOutsideClick ?? true,
        showCancelButton: configConfirm?.showCancelButton ?? true,
        confirmButtonColor: configConfirm?.confirmButtonColor ?? '',
        cancelButtonColor: configConfirm?.cancelButtonColor ?? '#eff2f7',
        confirmButtonText: configConfirm?.confirmButtonText ?? `${i18n.t('btn.ok')}`,
        cancelButtonText: configConfirm?.cancelButtonText ?? `${i18n.t('btn.cancel')}`
    }).then((result) => {
        return result.value ? true : false;
    });
}

function onHandleFakeId(dataOrigin) {
    const fakeId = dataOrigin.length <= 0 ? dataOrigin.length + 1 : Math.max(...dataOrigin.map((item) => item.id || item.make_id)) + 1;
    return fakeId;
}

function onHandleCheckFieldRequired(typeValidation) {
    if (
        typeValidation.includes('required') ||
        typeValidation.includes('requiredCustomMsg') ||
        typeValidation.includes('requiredDate') ||
        typeValidation.includes('requiredSelect')
    ) {
        return true;
    }
    return false;
}

function getInfoUserLocalStorage() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
}

function validateNumberRange(value, min = 0.01, max = 100, type = 'range') {
    const num = Number(value);
    let valid = true;
    if (Number.isNaN(num)) {
        valid = false;
    }
    if (type === 'range') {
        if (num < min || num > max) valid = false;
    }
    if (type === 'min') {
        if (value < min) valid = false;
    }
    if (type === 'max') {
        if (value > max) valid = false;
    }
    return valid;
}

function onScrollToFieldError(classError = 'invalid-feedback') {
    const firstElementValidateError = document.getElementsByClassName(classError)[0];
    if (firstElementValidateError) firstElementValidateError.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function onAutoResizeTextarea(elementOrId, defaultHeight = 37) {
    const element = typeof elementOrId === 'string' ? document.getElementById(elementOrId) : elementOrId;
    if (!element) return;
    element.style.overflow = 'hidden';
    const scrollHeight = element.scrollHeight;
    const newHeight = Math.max(scrollHeight, defaultHeight);
    element.style.height = newHeight + 'px';
}

function convertExtensionsToMimeTypes(extensions) {
    if (!extensions || !Array.isArray(extensions)) return [];
    return extensions
        .map((ext) => {
            const cleanExt = ext.toLowerCase().trim().replace(/^\.+/, '');
            return extensionToMimeType[cleanExt] || null;
        })
        .filter(Boolean);
}

function validateFileFormat(file, configUpload, bvToast) {
    let allowedExtension = configUpload?.allowedExtension;
    const lowCaseAllowedExtension = allowedExtension?.map((ext) => ext.toLowerCase());

    if (lowCaseAllowedExtension && (lowCaseAllowedExtension.includes('mov') || lowCaseAllowedExtension.includes('wmv'))) {
        if (!lowCaseAllowedExtension.includes('mp4')) {
            allowedExtension.push('mp4');
            lowCaseAllowedExtension.push('mp4');
        }
    }

    const lowCaseOriginName = file.name.split('.').pop().toLowerCase();
    if (!lowCaseAllowedExtension) return true;

    if (!lowCaseAllowedExtension?.includes(lowCaseOriginName)) {
        showMessage(8080, bvToast, i18n.t('uploadFile.format'));
        return false;
    }
    if (file.type) {
        // Only validate MIME type against the actual file's extension mapping,
        // not against all allowed extensions. This avoids false rejections for
        // file types like .key or .pem whose MIME varies across OS/browsers.
        const expectedMime = extensionToMimeType[lowCaseOriginName];
        if (expectedMime && file.type !== expectedMime) {
            showMessage(8080, bvToast, i18n.t('uploadFile.format'));
            return false;
        }
    }
    return true;
}

const getRealMimeType = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = function (e) {
            const ext = file.name.split('.').pop()?.toLowerCase() || '';
            let fallbackType = file.type || extensionToMimeType[ext] || 'unknown';

            if (!e.target || !e.target.result) return resolve(fallbackType);
            const arr = new Uint8Array(e.target.result);
            let header = '';
            for (let i = 0; i < arr.length; i++) {
                header += arr[i].toString(16).padStart(2, '0').toUpperCase();
            }

            let type = '';
            if (header.startsWith('89504E47')) type = 'image/png';
            else if (header.startsWith('FFD8')) type = 'image/jpeg';
            else if (header.startsWith('47494638')) type = 'image/gif';
            else if (header.startsWith('424D')) type = 'image/bmp';
            else if (header.startsWith('49492A00') || header.startsWith('4D4D002A')) type = 'image/tiff';
            else if (header.startsWith('00000100')) type = 'image/x-icon';
            else if (header.startsWith('25504446')) type = 'application/pdf';
            else if (header.startsWith('D0CF11E0')) type = ['doc', 'xls', 'ppt'].includes(ext) ? extensionToMimeType[ext] : 'application/msword';
            else if (header.startsWith('504B0304') || header.startsWith('504B0506') || header.startsWith('504B0708')) {
                const docxTypes = ['docx', 'xlsx', 'pptx', 'zip'];
                type = docxTypes.includes(ext) ? extensionToMimeType[ext] : 'application/zip';
            } else if (header.startsWith('52617221')) type = 'application/x-rar-compressed';
            else if (header.startsWith('377ABCAF')) type = 'application/x-7z-compressed';
            else if (header.startsWith('1F8B08')) type = 'application/gzip';
            else if (header.startsWith('494433') || header.startsWith('FFFB') || header.startsWith('FFF3') || header.startsWith('FFF2'))
                type = 'audio/mpeg';
            else if (header.startsWith('4F676753')) type = 'audio/ogg';
            else if (header.startsWith('464C56')) type = 'video/x-flv';
            else if (header.startsWith('1A45DFA3'))
                type = ['mkv', 'webm'].includes(ext) ? extensionToMimeType[ext] || 'video/x-matroska' : 'video/x-matroska';
            else if (header.startsWith('3026B275')) type = 'video/x-ms-wmv';
            else if (header.startsWith('52494646')) {
                const subHeader = header.substring(16, 24);
                if (subHeader === '57454250') type = 'image/webp';
                else if (subHeader === '57415645') type = 'audio/wav';
                else if (subHeader === '41564920') type = 'video/x-msvideo';
                else type = fallbackType;
            } else if (header.substring(8, 16) === '66747970') {
                // "ftyp" check
                const brand = header.substring(16, 24).toLowerCase();

                // heic: 68656963, heix: 68656978, hevc: 68657663, heis: 68656973
                // mif1: 6d696631, msf1: 6d736631
                if (brand === '68656963' || brand === '68656978' || brand === '68657663' || brand === '68656973') {
                    type = 'image/heic';
                } else if (brand === '6d696631' || brand === '6d736631') {
                    type = 'image/heif';
                } else if (['mp4', 'm4a', 'mov'].includes(ext)) {
                    type = extensionToMimeType[ext];
                } else {
                    type = 'video/mp4';
                }
            } else if (header.startsWith('3C3F786D6C') || header.startsWith('3C737667')) {
                type = ext === 'svg' ? 'image/svg+xml' : 'application/xml';
            } else if (header.startsWith('7B5C727466')) type = 'application/rtf';
            else {
                type = fallbackType;
            }
            resolve(type);
        };
        reader.onerror = () => {
            const ext = file.name.split('.').pop()?.toLowerCase() || '';
            resolve(file.type || extensionToMimeType[ext] || 'unknown');
        };
        reader.readAsArrayBuffer(file.slice(0, 12));
    });
};

const formatNumberLocale = (number, options = {}) => {
    return Number(number).toLocaleString(options);
};

export {
    checkPermission,
    checkPermissionName,
    isValidDate,
    onHandleShowConfirm,
    onHandleFakeId,
    onHandleCheckFieldRequired,
    getInfoUserLocalStorage,
    validateNumberRange,
    onScrollToFieldError,
    convertExtensionsToMimeTypes,
    validateFileFormat,
    getRealMimeType,
    onAutoResizeTextarea,
    formatNumberLocale
};
